import { render } from "./Steps3.vue?vue&type=template&id=7180e725"
import script from "./Steps3.vue?vue&type=script&lang=js"
export * from "./Steps3.vue?vue&type=script&lang=js"
script.render = render

export default script